import * as React from 'react';
import { useSelector } from 'react-redux';

import { details } from './content';
import { DealPriceSection } from '../../components/DealPriceSection';
import { trackNavigateToDealForm } from '../../utils/analytics';
import { selectDealFormUrl } from '../../selectors/promoInfo/selectDealFormUrl';
import { useApplicationContext } from '../../utils/applicationContext';
import { IPriceData } from '../../types/promoInfo/priceData';
import { ERuntimeSettings } from '../../types/runtimeSettings';

/**
 * Секция "Сколько стоит Циан.Сделка".
 */
export const DealPriceSectionContainer: React.FC<React.PropsWithChildren<unknown>> = () => {
  const dealFormUrl = useSelector(selectDealFormUrl);
  const { config } = useApplicationContext();

  const priceData = config.getStrict<IPriceData>(ERuntimeSettings.PriceData);

  const onCreateDealButtonClick = () => {
    trackNavigateToDealForm('price');
  };

  return (
    <DealPriceSection
      dealFormUrl={dealFormUrl}
      priceData={priceData}
      details={details}
      onCreateDealButtonClick={onCreateDealButtonClick}
    />
  );
};
